import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const deleteSession = async ({
  organisationId,
  sessionId,
}: {
  organisationId: string;
  sessionId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `${organisationId}/sessions/${sessionId}`,
  );
  return response.data;
};

export function useDeleteSession(
  queryOptions?: UseMutationOptions<void, HttpError, { sessionId: string }>,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: ({ sessionId }) =>
      deleteSession({ organisationId: organisation.id, sessionId }),
    ...queryOptions,
  });
}

const deleteRecurringSession = async ({
  organisationId,
  sessionId,
}: {
  organisationId: string;
  sessionId: string;
}): Promise<void> => {
  const response = await axiosClient.delete(
    `${organisationId}/sessions/recurring/${sessionId}`,
  );
  return response.data;
};

export function useDeleteRecurringSession(
  queryOptions?: UseMutationOptions<void, HttpError, { sessionId: string }>,
) {
  const { organisation } = useOrganisation();
  return useMutation({
    mutationFn: ({ sessionId }) =>
      deleteRecurringSession({ organisationId: organisation.id, sessionId }),
    ...queryOptions,
  });
}
